export default "__VITE_ASSET__c3f90151__"